export const CUSTOM = {
    display: 'Custom type',
    value: 'CUSTOM',
};

export const SYSTEM = {
    display: 'System type',
    value: 'SYSTEM',
};
